import {noop} from 'lodash';
import React, {FC, useEffect} from 'react';

import {reportToBugsnag} from '../../../../../libs/shared/core/src/services/bugsnag/bugsnag';
import {CellsFailed} from './cellsFailed';

/*
 * Props.
 */

interface CellsAuditTrailProps {}

/*
 * Component.
 */

/** Rendered when an audit trail cells panel page is encountered in an inboxes panel. This shouldn't happen. */
export const CellsAuditTrail: FC<CellsAuditTrailProps> = () => {
  useEffect(() => {
    reportToBugsnag(new Error('Unexpected audit trail page in an inboxes panel'));
  }, []);

  return <CellsFailed onRetryClick={noop} />;
};
